import o, { useContext as n, createContext as a } from "react";
const r = a("default"), c = ({
  theme: e = "default",
  children: t
}) => /* @__PURE__ */ o.createElement(r.Provider, { value: e }, t), s = (e) => {
  const t = n(r);
  return e || t;
};
export {
  c as T,
  s as u
};
